<!-- 图片库 -->
<template>
    <div>
        <Modal v-model="switch_modal" :mask-closable="false" width="1200">
            <div>
                <!-- 标题 -->
                <div class="modal_title">选择文件</div>
                <!-- 获取当前用户剩余空间 -->
                <span class="modal_span">
                    {{ freeSpace.surplus }}/{{ freeSpace.total }}
                    <Icon class="cursor-p" type="md-refresh" size="18" @click="get_getInfo()"/>
                </span>
                <!-- 主题内容 -->
                <div class="main">
                    <!-- 左侧内容 -->
                    <div class="left">
                        <Button class="addbtn" size="large" @click="add">添加分组</Button>
                        <!-- v-for分组 -->
                        <!-- '全部'不循环 -->
                        <div :class="[{ active: lotItem == -1 }, 'lot']" @click="lotactiveccc">
                            <template v-if="lotItem == -1">
                                <img class="width_height_18" src="../../assets/library4.png"/>
                            </template>
                            <template v-else>
                                <img class="width_height_18" src="../../assets/library1.png"/>
                            </template>
                            <span class="lot_name">全部</span>
                        </div>
                        <div :class="[{ active: lotItem == index }, 'lot']" v-for="(item, index) in lotArr" :key="index" @click="lotactivefun(index, item.id)">
                            <template v-if="lotItem == index">
                                <img class="width_height_18" src="../../assets/library4.png"/>
                            </template>
                            <template v-else>
                                <img class="width_height_18" src="../../assets/library1.png"/>
                            </template>
                            <span class="lot_name">{{ item.name }}</span>
                            <img class="lot_edit" src="@/assets/library2.png" @click.stop="edit(item)"/>
                            <img class="lot_edit" src="@/assets/library3.png" @click.stop="del(item.id)"/>
                        </div>
                    </div>
                    <!-- 右侧内容 -->
                    <div class="right">
                        <div v-if="imgArr.length == 0">
                            <div class="img_bg">
                                <div class="img_div">
                                    <img class="width_height_100" src="../../assets/library_bg.png"/>
                                </div>
                                <span style="color: #7c8499">暂无图片，请先上传图片</span>
                            </div>
                        </div>
                        <div class="offside">
                            <!-- upload -->
                            <Upload
                                class="margin_top_5"
                                multiple
                                ref="upload"
                                :show-upload-list="false"
                                :format="['jpg','jpeg','png','gif','mp4','avi','mov']"
                                :max-size="51200"
                                :headers="headers"
                                :on-exceeded-size="exceededSize"
                                :on-format-error="handleFormatError"
                                :on-progress="handleProgress"
                                :on-success="picImgSuccess"
                                :action="uploads"
                                :data="imgUpload"
                            >
                                <div class="upload_add">
                                    <div class="upload_addIcon">+</div>
                                </div>
                            </Upload>
                            <!-- v-for图片 -->
                            <div
                                v-for="(item, index) in imgArr"
                                :key="index"
                                :class="[
                                    {
                                        imageactive:
                                            newimgsrc.findIndex(
                                                (it) =>
                                                    it.random_number ==
                                                    item.random_number
                                            ) != -1,
                                    },
                                    'offside_box',
                                ]"
                                @click="imgactivefun(index, item)"
                            >
                                <div class="video_div">
                                    <video 
                                        class="width_height_100"
                                        v-if="
                                            getLastSegmentAfterDot(
                                                item.original_name
                                            )
                                        "
                                        :src="item.path ? item.path : imgPrefix + item.random_number"
                                    ></video>
                                    <img
                                        class="width_height_100"
                                        v-else
                                        :src="item.path ? item.path : imgPrefix + item.random_number"
                                    />
                                    <div class="demo_upload_list_cover">
                                        <div @click.stop="handleRemove(item)">
                                            <img src="../../assets/library_del.png"/>
                                        </div>
                                    </div>
                                </div>
                                <p class="offside_pname">{{ item.original_name }}</p>
                            </div>
                            <Page
                                class="offside_page"
                                show-total
                                :total="page.total"
                                :current="page.page"
                                :page-size="page.limit"
                                @on-change="changeIndexPage"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <!-- 大MODAL自定义页脚 -->
            <div slot="footer">
                <Button @click="closeModal">取消</Button>
                <Button class="modal_footbtn" v-if="newimgsrc.length > 0" @click="modalSet">确认</Button>
            </div>
            <div slot="close" @click="closeModal">
                <i class="ivu-icon ivu-icon-ios-close"></i>
            </div>
        </Modal>
        <!-- modal-增、改 -->
        <Modal v-model="modaladd" style="z-index: 3000 !important;">
            <p slot="header">
                <span class="modal_title">{{ title }}</span>
            </p>
            <div class="modal_content">
                <span class="left_span">分组名称：</span>
                <Input class="left_input" v-model="btn_form.name" show-word-limit maxlength="8" placeholder="请输入分组名称"/>
            </div>
            <div slot="footer">
                <Button @click="modaladd = false">取消</Button>
                <Button class="modal_footbtn" @click="update">保存</Button>
            </div>
        </Modal>
        <!-- modal-删 -->
        <Modal v-model="modaldel" style="z-index: 3000 !important;">
            <p slot="header">
                <span class="modal_title">{{ title }}</span>
            </p>
            <div class="modal_content">
                <span class="del_span">是否确认删除分组！</span>
            </div>
            <div slot="footer">
                <Button @click="modaldel = false">取消</Button>
                <Button class="modal_footbtn" @click="delete_need">保存</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import {
    createFolder,
    showFolder,
    delFolder,
    showImgList,
    getInfo,
    delImg,
} from "@/api/oss";
import config from "@/config";
import { getCookies } from "@/utils/helper";
export default {
    // 控制大MODAL开关
    props: {
        switch_modal: {
            type: Boolean,
            default: false,
        },
        select: {
            type: Number,
            default: 0,
        },
        select_type: {
            type: String,
            default: "image",
        },
    },
    data() {
        return {
            pushed: false,
            imgUpload: {
                folder_id: "0",
            }, //图片上传参数
            imgPrefix: "", //getInfo()--获取当前用户剩余空间--获取图片地址前缀
            freeSpace: {}, //剩余空间
            lotItem: -1, //分组列表激活辅助参数
            headers: { "hlzw-suyuan-token": getCookies("pcToken") },
            uploads: config.apiUrl + "/api/libray/uploads",
            btn_form: {
                name: "",
            }, //创建或修改目录
            title: "", //modal_title
            modaladd: false, //控制modal开关
            modaldel: false, //控制modal开关
            lotArr: [], //显示目录
            imgArr: [], //显示图片列表
            page: {
                limit: 20, // 一页展示多少数据
                page: 1, // 当前展示分页
                folder_id: 0,
            }, //显示图片列表(参数)
            imagesrc: "", //选中图片路径
            newimgsrc: [],
            progressCalls: 0,
        };
    },
    mounted() {
        this.get_showFolder(); //显示目录
        this.get_getInfo(); //获取当前用户剩余空间
        this.get_showImgList(); //显示图片列表
    },
    methods: {
        getLastSegmentAfterDot(str) {
            const lastIndex = str.lastIndexOf(".");
            let text = "";
            if (lastIndex !== -1 && lastIndex < str.length - 1) {
                text = str.substring(lastIndex + 1);
            } else {
                text = "";
            }
            if (text == "mp4" || text == "avi" || text == "mov") {
                return true;
            } else {
                return false;
            }
        },
        //获取当前用户剩余空间
        get_getInfo() {
            getInfo().then((res) => {
                this.freeSpace = res.data;
                this.imgPrefix = res.data.domain;
            })
            .catch((res) => {
                this.$Message.error(res.msg);
            });
        },
        //显示图片列表 -- page分页
        get_showImgList(e) {
            showImgList(this.page).then((res) => {
                this.imgArr = res.data.data;
                this.page.total = res.data.total;
            })
            .catch((res) => {
                this.$Message.error(res.msg);
            });
        },
        changeIndexPage(p) {
            // p是分页中当前页的页码
            this.page.page = p;
            this.get_showImgList();
            //取消选中图片
        },
        //删除图片
        handleRemove(file) {
            delImg({ random: file.random_number }).then((res) => {
                this.get_getInfo();
                this.get_showImgList();
            })
            .catch((res) => {
                this.$Message.error(res.msg);
            });
        },
        //upload
        // 文件上传成功---图片上传
        picImgSuccess(e) {
            if(e.code == 200){
                this.get_getInfo();
                this.get_showImgList();
                this.$Message.destroy();
                this.$Message.success("上传成功");
                this.progressCalls = 0;
            }else{
                this.$Message.destroy();
                this.$Message.warning("暂不支持上传此格式");
                this.progressCalls = 0;
            }
        },
        //文件上传错误
        handleFormatError() {
            this.$Message.warning("暂不支持上传此格式");
        },
        exceededSize(e) {
            this.$Message.warning("文件大小限制在50MB以内");
        },
        // 文件上传时
        handleProgress(e) {
            this.progressCalls++;
            if (this.progressCalls == 1) {
                if (e.percent == 100) {
                    this.$Message.loading({
                        content: "上传中...",
                        duration: 0,
                    });
                    return;
                }
                this.$Message.loading({
                    content: "上传中...",
                    duration: 0,
                });
            }
        },
        //GET请求
        get_showFolder() {
            showFolder().then((res) => {
                this.lotArr = res.data;
            })
            .catch((res) => {
                this.$Message.error(res.msg);
            });
        },
        //激活分组列表
        lotactivefun(e, i) {
            this.lotItem = e;
            this.page.folder_id = i;
            this.page.page = 1;
            this.imgUpload.folder_id = i;
            this.get_showImgList();
        },
        //激活分组列表--'全部'
        lotactiveccc() {
            this.lotItem = -1;
            this.page.folder_id = 0;
            this.page.page = 1;
            this.imgUpload.folder_id = 0;
            this.get_showImgList(); //显示图片列表
            //取消选中图片
        },
        //激活图片列表
        // 点大modal的确认时要用
        imgactivefun(i, e) {
            let num = this.newimgsrc.findIndex(
                (item) => item.random_number == e.random_number
            );
            if (num == -1) {
                //选中
                if (
                    this.select_type == "video" && !this.getLastSegmentAfterDot(e.original_name)
                ) {
                    this.$Message.error("请选择视频");
                    return;
                }
                if (
                    this.select_type == "image" && this.getLastSegmentAfterDot(e.original_name)
                ) {
                    this.$Message.error("请选择图片");
                    return;
                }
                if (this.select === 0) {
                    // 在select值为0时可以一直push
                    this.newimgsrc.push(e);
                } else {
                    if (!this.pushed) {
                        // 只在select值为1时执行一次push操作
                        this.newimgsrc.push(e);
                        if (this.newimgsrc.length == 2) {
                            this.newimgsrc.splice(0, 1);
                        }
                    }
                }
            } else {
                //删除
                this.newimgsrc.splice(num, 1);
                this.pushed = false;
            }
        },
        //增
        add() {
            this.title = "添加分组";
            this.modaladd = true;
            this.btn_form = {name: "",};
        },
        //改
        edit(e) {
            this.title = "分组管理";
            this.modaladd = true;
            this.btn_form.name = e.name;
            this.btn_form.id = e.id;
        },
        //删
        del(e) {
            this.title = "删除分组";
            this.modaldel = true;
            this.btn_form.id = e;
        },
        // POST增、改
        update() {
            if (this.btn_form.name == "") {
                this.$Message.error("分组名称不能为空");
                return;
            }
            createFolder(this.btn_form).then((res) => {
                this.get_showFolder();
                this.$Message.success(res.msg);
            })
            .catch((res) => {
                this.$Message.error(res.msg);
            });
            this.modaladd = false;
        },
        //POST删
        delete_need() {
            delFolder({ id: this.btn_form.id }).then((res) => {
                this.get_showFolder();
                this.$Message.success(res.msg);
            })
            .catch((res) => {
                this.$Message.error(res.msg);
            });
            this.modaldel = false;
        },
        //大MODAL开关
        closeModal() {
            this.$emit("update:switch_modal", false);
        },
        //大MODAL开关--确认按钮
        modalSet() {
            this.$emit("update:switch_modal", false);
            var byValue = [];
            var byValueSrc = [];
            this.newimgsrc.forEach((item) => {
                byValue.push(this.imgPrefix + item.random_number);
                byValueSrc.push(item.random_number);
            });
            // 向父组件传递了1个值
            if (this.newimgsrc.length >= 0) {
                this.$emit("change", byValue, byValueSrc);
            }
        },
    },
};
</script>

<style scoped>
.modal_title {
    width: 100px;
    font-size: 20px;
    user-select: none;
}
.modal_content {
    width: 100%;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.main {
    height: 550px;
    margin-top: 30px;
    display: flex;
}
.left {
    width: 250px;
    height: 550px;
    background: #ffffff;
    border: 1px solid #999999;
    overflow: auto;
}
/* 滚动条 */
.left::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
}
.left::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    -webkit-box-shadow: inset 0 0 1px 0 rgba(0, 0, 0, 0.15);
    background: rgba(144, 147, 153, 0.3);
}
.left::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 1px 0 rgba(0, 0, 0, 0.15);
}
/* 左侧添加分组btn */
.addbtn {
    background: #ff761d;
    color: #fff;
    border-color: #ff761d;
    margin: 12px 0 24px 24px;
}
.modal_footbtn {
    background: #ff761d;
    color: #fff;
    border-color: #ff761d;
}
/* 左侧列表lot */
.width_height_18 {
    width: 18px;
    height: 18px;
}
.lot_name {
    width: 200px;
    margin-left: 12px;
    font-size: 14px;
    user-select: none;
}
.lot_edit {
    width: 26px;
    height: 26px;
    margin-right: 12px;
}
.lot {
    padding: 24px 0 24px 24px;
    width: 100%;
    height: 30px;
    display: flex;
    align-items: center;
    position: relative;
    cursor: pointer;
}
.lot:hover {
    background-color: #f8e3d5;
}
/* 分组列表激活样式 */
.active {
    background-color: #f8e3d5;
}
.active span {
    color: #ff761d;
}
.right {
    width: 900px;
    height: 550px;
    background: #ffffff;
    border: 1px solid #999999;
    border-left: 0;
    position: relative;
}
.offside {
    margin: 24px;
    width: 850px;
    display: flex;
    flex-wrap: wrap;
}
.upload_add {
    margin: 12px;
    width: 100px;
    height: 100px;
    background: #ecf0f3;
    border: 1px solid #dadada;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.upload_add:hover {
    border: 1px solid #ff761d;
}
.upload_add:active {
    border: 1px solid #ff761d;
}
.upload_addIcon {
    font-size: 50px;
    color: #c0c4cc;
}
.upload_add:hover .upload_addIcon {
    color: #ff761d;
}
.upload_add:active .upload_addIcon {
    color: #ff761d;
}
.offside_box {
    margin: 12px 5px;
    padding: 5px;
    width: 110px;
    height: 130px;
    text-align: center;
    position: relative;
    cursor: pointer;
}
.offside_box:hover {
    box-shadow: 3px 3px 3px 3px rgba(0, 0, 0, 0.05);
}
/* 图片列表激活样式 */
.imageactive {
    background-color: #f8e3d5;
    border: 1px solid #ff761d;
    border-radius: 5px;
}
.offside_pname {
    width: 100px;
    user-select: none;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.offside_page {
    position: absolute;
    bottom: 10px;
    right: 20px;
}
.demo_upload_list_cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}
.offside_box:hover .demo_upload_list_cover {
    display: block;
}
.img_bg {
    width: 400px;
    height: 250px;
    position: absolute;
    top: 150px;
    left: 250px;
    text-align: center;
}
.demo_upload_list_cover div img {
    width: 20px;
    height: 20px;
    cursor: pointer;
    position: absolute;
    right: 0;
    top: 0;
    margin-top: -15px;
    margin-right: -15px;
}
::v-deep .ivu-modal-body {
    max-height: 700px;
}
.modal_span {
    position: absolute;
    right: 50px; 
    user-select: none;
}
.left_span {
    width: 100px; 
    font-size: 16px;
}
.left_input {
    width: 100%; 
    user-select: none;
}
.del_span {
    font-size: 16px;
}
.img_div {
    width: 400px;
    height: 200px;
}
.width_height_100 {
    width: 100%;
    height: 100%;
}
.margin_top_5 {
    margin-top: 5px;
}
.video_div {
    width: 100px;
    height: 100px;
    position: relative;
}
::v-deep .ivu-modal-mask {
    z-index: 2222 !important;
}
::v-deep .ivu-modal-wrap {
    z-index: 2222 !important;
}
</style>